<template>
  <div>
    <div ref='barchart' class='echartbox' :style="{width: chartWidth,height: chartHeight}">
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
// 引入饼图组件
require("echarts/lib/chart/bar");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
export default {
  name: "bar",
  props: {
    // tite: "", //图名
    bardata: [Object, Array],
    name: String,
    // title: {
    //   type: [String, String],
    //   default: ""
    // },
    legend: Object,
    chartWidth: {
      type: [String, Number],
      default: "500px"
    },
    chartHeight: {
      type: [String, Number],
      default: "200px"
    },
    chartColor: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      title: "",
      xAxis_data: [],
      series_data: []
    };
  },
  mounted() {
    this.initChart();
  },
  watch: {
    bardata: {
      handler() {
        this.initChart();
      },
      deep: true
    }
  },
  methods: {
    initChart() {
       this.xAxis_data=[];
      if (Object.prototype.toString.call(this.bardata) == "[object Array]") {
         this.bardata.forEach(item=>{
          this.xAxis_data.push(item.name)
      })
      } 
     
      this.series_data=this.bardata;
      const initCharts = echarts.init(this.$refs.barchart);
      const options = {
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "10%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxis_data,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            type: "bar",
            barWidth: "60%",
            data: this.series_data
          }
        ]
      };

      initCharts.setOption(options);
    }
  }
};
</script>
